// import { appendScript } from "./loadScript.service";
// export const elementService = {};
// // loading the script file from the server so it is writen only once;
// appendScript('/elementService', 'elementServiceModule', elementService);


export const elementService = window.elementServiceModule.elementService;